export const INITIAL_REQUEST = 'INITIAL / INITIAL_REQUEST';
export const LOAD_COMPANY = 'COMPANY / LOAD_COMPANY';
